import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import FullPageLoader from "../component/common/FullPageLoader";
import { useAppNavigate } from "./useAppNavigate";
import { useLoginUser } from "../hooks/useLoginUser";
import { notify } from "lib/notify";

/**
 * ユーザーが担当ビル未選択の場合、ビル選択画面に遷移させる
 */
const WorkerGurad = () => {
  const { meNavigate } = useAppNavigate();
  const { isFetching, isAssignedToBuilding, isWorker } = useLoginUser();

  useEffect(() => {
    if (!isAssignedToBuilding) {
      const infoMessage = isWorker
        ? "ビル情報が取得できません。管理者に問い合わせてください。"
        : "利用ビルを設定してください";
      notify(infoMessage, "info");
      if (isWorker) {
        meNavigate.detail();
        return;
      }
      meNavigate.setCurrentBuilding();
    }
  }, [isAssignedToBuilding, meNavigate, isWorker]);

  if (!isAssignedToBuilding || isFetching) return <FullPageLoader />;

  return <Outlet />;
};

export default WorkerGurad;
